export default __webpack_public_path__ + "static/DSC_0297-7036ee6dc61f7506c8f8d19852c02402.jpg";